import { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";

// Lazy-loaded components
const View = Loadable(lazy(() => import("../View")));
const MasterListOfMachine = Loadable(lazy(() => import("../MasterListOfMachine")));
const PreventiveMachinePlan = Loadable(lazy(() => import("../PreventiveMachinePlan")));
const PreventiveMaintenanceReport = Loadable(lazy(() => import("../PreventiveMaintenanceReport")));
const MachineBreakDownList = Loadable(lazy(() => import("../MachineBreakDownList")));

const PreventiveMaintenanceRoutes = [
  {
    path: routeConstants.PREVENTIVE_MAINTAINCE,
    children: [
      {
        path: "detail/:id",
        element: <View />,
      },
      {
        path: "maintenance-plan/:id",
        element: <PreventiveMachinePlan />,
      },
      {
        path: "maintenance-report/:id",
        element: <PreventiveMaintenanceReport />,
      },
      {
        path: "machine-break-downlist/:id?",
        element: <MachineBreakDownList />,
      },
      {
        path: "machine-break-downList/:year",
        element: <MachineBreakDownList />,
      },
      {
        path: "master-list-of-machine",
        element: <MasterListOfMachine />,
      },
    ],
  },
];

export default PreventiveMaintenanceRoutes;
